import { Outlet } from 'react-router-dom';
import { TopBar } from 'app/agriculture/FarmMain/TopBar/TopBar';
import { CesiumAttribution } from 'app/agriculture/AgricultureMap/components/CesiumAttribution/CesiumAttribution';
import { AgTimeline } from 'app/agriculture/AgTimeline/AgTimeline';
import { AgricultureMap } from 'app/agriculture/AgricultureMap/AgricultureMap';
import { useSelectionServiceRouterConnectionEffect } from 'app/agriculture/hooks/useSelectionServiceRouterConnectionEffect';
import { useNavigateForServicesInitialisationEffect } from 'app/agriculture/FarmMain/useNavigateForServicesInitialisationEffect';
import { ToolStack } from 'app/agriculture/components/Tools/ToolStack';
import { MapRenderer } from 'app/agriculture/FarmMain/MapRenderer/MapRenderer';
import 'app/agriculture/FarmMain/FarmMain.scss';
import {
    SuspenseWrapper,
    ToastError,
} from 'app/agriculture/components/SuspenseWrapper/SuspenseWrapper';
import { ContextMenu } from 'app/agriculture/ContextMenu/ContextMenu';
import { AgMapBoxStack } from 'app/agriculture/AgMapBoxStack/AgMapBoxStack';
import { AppLogoSection } from 'app/agriculture/FarmMain/AppLogoSection';
import { GlobalContextProvider } from 'app/agriculture/contexts/GlobalContextProvider';
import { PrefetchSnapshots } from 'app/agriculture/queries/snapshots/PrefetchSnapshots';

export function FarmMain() {
    return (
        <GlobalContextProvider>
            <PrefetchSnapshots>
                <div className="FarmMain">
                    <SuspenseWrapper loadingComponent={null} ErrorComponent={ToastError}>
                        <EffectRenderer />
                    </SuspenseWrapper>
                    <SuspenseWrapper loadingComponent={null} ErrorComponent={ToastError}>
                        <div className="FarmMain__content">
                            <div className="FarmMain__side">
                                <AppLogoSection />
                                <AgMapBoxStack />
                                <CesiumAttribution className="FarmMain__attribution" />
                            </div>
                            <div className="FarmMain__main">
                                <TopBar />
                                <div className="FarmMain__outlet">
                                    <Outlet />
                                </div>
                                <ToolStack />
                            </div>
                            <ContextMenu />
                        </div>
                        <AgTimeline />
                    </SuspenseWrapper>
                    <AgricultureMap className="FarmMain__map" />
                    <MapRenderer />
                </div>
            </PrefetchSnapshots>
        </GlobalContextProvider>
    );
}

// This is for magic side effects that should probably all be rewritten or removed at some point
function EffectRenderer() {
    useNavigateForServicesInitialisationEffect();
    useSelectionServiceRouterConnectionEffect();
    return <></>;
}
